import React from 'react';
import {
  ColumnInformation,
  joinClassNames,
  TableSorterField,
  TableSorterInformation,
} from '@utahdts/dts-react-common';
import Icon from '../../misc/Icon';
import RowActionsPopover from '../../misc/RowActionsPopover';
import TableSorterSortType from '@utahdts/dts-react-common/components/table-sorter/TableSorterSortType';
import TableSorterDirection from '@utahdts/dts-react-common/components/table-sorter/TableSorterDirection';
import { dateTd, textTd } from '../../misc/Shared';

const sorters = {
  ndc: new TableSorterField(
    'ndc',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  increaseAmount: new TableSorterField(
    'increaseAmount',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  effectiveDate: new TableSorterField(
    'effectiveDate',
    TableSorterSortType.DATE,
    TableSorterDirection.ASCENDING,
  ),
  increaseFactors: new TableSorterField(
    'increaseFactors',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  creationDate: new TableSorterField(
    'createdDate',
    TableSorterSortType.DATE,
    TableSorterDirection.DESCENDING,
  ),
};

const defaultSorters = (firstSorter) =>
  new TableSorterInformation([
    firstSorter,
    ...Object.values(sorters).filter((sorter) => sorter !== firstSorter),
  ]);

export default (editWac, deleteWac) => {
  const customTd = (columnInfo, data) => {
    return (
      <td key={joinClassNames(columnInfo.field, data.name)}>
        <RowActionsPopover>
          <ul className="actions">
            <li
              className="actions-item"
              onClick={() => editWac(true, data, true)}
            >
              {Icon.iconEye()} View WAC
            </li>
            <li className="actions-item" onClick={() => deleteWac(data)}>
              {Icon.iconTrash()} Delete WAC
            </li>
          </ul>
        </RowActionsPopover>
      </td>
    );
  };

  return [
    new ColumnInformation({
      title: 'NDC',
      field: 'ndc',
      tableSorterInformation: defaultSorters(sorters.ndc),
    }),
    new ColumnInformation({
      title: 'Increase Amount',
      field: 'increaseAmount',
      tableSorterInformation: defaultSorters(sorters.increaseAmount),
    }),
    new ColumnInformation({
      title: 'Effective Date',
      field: 'effectiveDate',
      tableSorterInformation: defaultSorters(sorters.effectiveDate),
      tdCallback: (columnInfo, data) => dateTd(columnInfo, data, false),
    }),
    new ColumnInformation({
      title: 'Increase Factors',
      field: 'increaseFactors',
      tableSorterInformation: defaultSorters(sorters.increaseFactors),
      tdCallback: textTd,
    }),
    new ColumnInformation({
      title: 'Date Submitted',
      field: 'createdDate',
      tableSorterInformation: defaultSorters(sorters.creationDate),
      tdCallback: (columnInfo, data) => dateTd(columnInfo, data, true),
    }),
    new ColumnInformation({
      title: 'Actions',
      field: 'actions',
      tdCallback: (columnInfo, data) => customTd(columnInfo, data),
      filter: false,
    }),
  ];
};
